<script setup>
import {computed, inject, reactive, ref, onMounted} from "vue";
//import functions
//import components
import {InputText, FloatLabel, Dialog, Listbox, MultiSelect, DatePicker, Select} from "primevue";
import {Icon} from "@iconify/vue";
//import stores
import {useBoostPaymentStore2} from "@/stores/payment-boost2.js";
import {useConfigStore} from "@/stores/config.js";
import {useCurrencyPricesStore} from "@/stores/currencyPrices.js";
//import composables
import {useBreakpoint} from "@/composables/useBreakpoint.js";
import {useLoadingFlags} from "@/composables/useLoadingFlags.js";
import {useToast} from "primevue/usetoast";
import {useConfigData} from "@/composables/useConfigData.js";
import {showMessage} from "@/utils/showMessage.js";


//stores
const paymentStore = useBoostPaymentStore2();
const configStore = useConfigStore();
const currencyPricesStore = useCurrencyPricesStore();

//loading flags
const {
  saving,
  fetching,
  loading,
  setSaving,
  setFetching,
  setLoading,
} = useLoadingFlags()

//composables
const {isXL} = useBreakpoint();
const toast = useToast();
const {games} = useConfigData('Boost')

//emits
const emit = defineEmits(['update:filters']);

//props
const props = defineProps({
  /*selectedHotOrder: {
    type: Object,
    required: true
  }*/
});

//injects
const visible = inject('isShowFiltersModal')

//component variables
const createdFromModel = computed({
  get() {
    if (filters.createdFrom && !isNaN(filters.createdFrom)) {
      return new Date(Number(filters.createdFrom));
    }
    return null;
  },
  set(value) {
    if (value instanceof Date) {
      filters.createdFrom = value.getTime();
    } else {
      filters.createdFrom = '';
    }
  }
})
const createdToModel = computed({
  get() {
    if (filters.createdTo && !isNaN(filters.createdTo)) {
      return new Date(Number(filters.createdTo));
    }
    return null;
  },
  set(value) {
    if (value instanceof Date) {
      filters.createdTo = value.getTime();
    } else {
      filters.createdTo = '';
    }
  }
})
const updatedFromModel = computed({
  get() {
    if (filters.updatedFrom && !isNaN(filters.updatedFrom)) {
      return new Date(Number(filters.updatedFrom));
    }
    return null;
  },
  set(value) {
    if (value instanceof Date) {
      filters.updatedFrom = value.getTime();
    } else {
      filters.updatedFrom = '';
    }
  }
})
const updatedToModel = computed({
  get() {
    if (filters.updatedTo && !isNaN(filters.updatedTo)) {
      return new Date(Number(filters.updatedTo));
    }
    return null;
  },
  set(value) {
    if (value instanceof Date) {
      filters.updatedTo = value.getTime();
    } else {
      filters.updatedTo = '';
    }
  }
})

const currencyPrices = ref([])
const excludeCurrencyPrices = ["Toman Gold Buy Manual", "Toman Gold Buy Auto", "Toman Shop"];
const states = ['New', 'Assigned', 'Delivering', 'Delivered', 'Canceled', 'Paid']
const stateColorsMap = {
  New: 'bg-[#9E9E9E]',
  Assigning: 'bg-[#EFECDC]',
  Assigned: 'bg-[#FFEB01]',
  Delivering: 'bg-[#FF9800]',
  Delivered: 'bg-[#2196F3]',
  Canceled: 'bg-[#F44336]',
  Paid: 'bg-[#4CAF50]',
}

const currencies = ref(paymentStore.currencies)
const filters = reactive({
  'finalized': paymentStore.filters.finalized,
  'stores': paymentStore.filters.stores,
  'games': paymentStore.filters.games,
  'states': paymentStore.filters.states,
  'createdFrom': paymentStore.filters.createdFrom,
  'createdTo': paymentStore.filters.createdTo,
  'updatedFrom': paymentStore.filters.updatedFrom,
  'updatedTo': paymentStore.filters.updatedTo,
  'lastUpdate': null
})

//global functions

//component functions
const applyFilter = () => {
  paymentStore.resetLastUpdate()
  paymentStore.isImmediateRequest = true
  paymentStore.filters = filters;
  paymentStore.currencies = currencies.value;
  paymentStore.isLoading = true
  visible.value = false
}
/*const applyFilter = () => {
  paymentStore.resetLastUpdate()
  paymentStore.boostOrders = []
  paymentStore.filters = filters;
  paymentStore.currencies = currencies.value;
  paymentStore.action_getSubOrders()
  //paymentStore.isImmediateRequest = true
  //paymentStore.isLoading = true
  visible.value = false
}*/

const resetFilters = () => {
  filters.stores = [];
  filters.games = [];
  filters.states = [];
  filters.createdFrom = null;
  filters.createdTo = null;
  filters.updatedFrom = null;
  filters.updatedTo = null;
  currencies.value = [];
}

function selectNow_createdFrom() {
  const now = new Date();
  filters.createdFrom = now.getTime();
}

function clear_createdFrom() {
  filters.createdFrom = '';
}
function selectNow_createdTo() {
  const now = new Date();
  filters.createdTo = now.getTime();
}

function clear_createdTo() {
  filters.createdTo = '';
}
function selectNow_updatedFrom() {
  const now = new Date();
  filters.updatedFrom = now.getTime();
}

function clear_updatedFrom() {
  filters.updatedFrom = '';
}
function selectNow_updatedTo() {
  const now = new Date();
  filters.updatedTo = now.getTime();
}

function clear_updatedTo() {
  filters.updatedTo = '';
}

const getCurrencies = async (refresh) => {
  try {
    if (!refresh) setLoading(true)
    const res = await currencyPricesStore.action_getPrices();
    if (res.result === true) {
      currencyPrices.value = res.data;
    } else {
      //toast.add({severity: 'error', summary: 'Failed', detail: res, life: 1500});
      showMessage(res, 'error');
    }
  } catch (err) {
    //toast.add({severity: 'error', summary: 'Failed', detail: err, life: 1500});
    showMessage(err, 'error');
  } finally {
    setLoading(false)
  }
}

//hooks
onMounted(() => {
  getCurrencies(false)
})

//provides
</script>
<template>
  <Dialog v-model:visible="visible"
          :class="['max-w-3xl !border-0 !rounded-md !bg-[#0e1726]', isXL ? '' : 'w-full']"
          :position="isXL ? 'center' : 'bottom'"
          closable dismissable-mask draggable modal
          content-class="flex flex-col gap-4 overflow-hidden h-full w-full max-w-[calc(100vw-20px)] max-h-[calc(100vh-100px)]">
    <template #header>
      <div class="flex flex-row justify-between w-full">
        <div class="text-base py-3">
          Filters
        </div>
        <button @click="resetFilters" class="hover:underline text-xs">Reset Filters</button>
      </div>
    </template>
    <template #closebutton="{closeCallback}">
      <div class="h-full w-[1px] bg-slate-700"></div>
      <button
          type="button"
          class="text-white-dark outline-none hover:text-red-500"
          @click="closeCallback"
      >
        <Icon icon="pajamas:close-xs"/>
      </button>
    </template>
    <div class="flex-1 flex flex-col gap-4 overflow-y-auto pt-4 pb-1 text-xs 2xl:text-sm min-w-80 max-w-full">
      <div class="grid grid-cols-12 gap-4">
        <FloatLabel class="col-span-4 max-w-[320px] custom-multiselect" variant="on">
          <MultiSelect v-model="currencies" inputId="currency" display="chip"
                       :options="currencyPrices.filter(item => !excludeCurrencyPrices.includes(item.name))"
                       optionLabel="name" optionValue="name" :loading="loading"
                       filter auto-filter-focus show-clear
                       :maxSelectedLabels="0"
                       class="w-full min-w-28 !bg-transparent h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                       input-class="!text-xs 2xl:!text-sm"
                       overlayClass="custom-select-overlay"/>
          <label for="currency" class="!bg-slate-900">Currency</label>
        </FloatLabel>
        <FloatLabel class="col-span-4 max-w-[320px] custom-multiselect" variant="on">
          <MultiSelect v-model="filters.games" inputId="game" display="chip"
                       :options="configStore.configs.allGames"
                       optionLabel="game"
                       optionValue="game"
                       filter auto-filter-focus show-clear
                       :maxSelectedLabels="0"
                       class="w-full min-w-28 !bg-transparent h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                       input-class="!text-xs 2xl:!text-sm"
                       overlayClass="custom-select-overlay"/>
          <label for="game" class="!bg-slate-900">Game</label>
        </FloatLabel>
        <FloatLabel class="col-span-4 max-w-[320px] custom-multiselect" variant="on">
          <MultiSelect v-model="filters.states" inputId="state" display="chip"
                       :options="states"
                       show-clear
                       :maxSelectedLabels="0"
                       class="w-full min-w-28 !bg-transparent h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700"
                       input-class="!text-xs 2xl:!text-sm"
                       overlayClass="custom-select-overlay"/>
          <label for="state" class="!bg-slate-900">State</label>
        </FloatLabel>
        <div class="col-span-6 flex flex-col gap-0.5 text-xs 2xl:text-sm">
          <FloatLabel variant="on">
            <DatePicker
                inputId="createdFrom"
                v-model="createdFromModel"
                hourFormat="24"
                dateFormat="d M yy"
                fluid
                :showButtonBar="true"
                class="flex-1"
                size="small"
                :input-class="['!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700']"
                showIcon
                iconDisplay="input"
            >
              <template #todaybutton>
                <span @click="selectNow_createdFrom"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Now</span>
              </template>
              <template #clearbutton>
                <span @click="clear_createdFrom"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Clear</span>
              </template>
            </DatePicker>
            <label for="createdFrom" class="!bg-slate-900">Create From</label>
          </FloatLabel>
        </div>
        <div class="col-span-6 flex flex-col gap-0.5 text-xs 2xl:text-sm">
          <FloatLabel variant="on">
            <DatePicker
                inputId="createdTo"
                v-model="createdToModel"
                hourFormat="24"
                dateFormat="d M yy"
                fluid
                :showButtonBar="true"
                class="flex-1"
                size="small"
                :input-class="['!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700']"
                showIcon
                iconDisplay="input"
            >
              <template #todaybutton>
                <span @click="selectNow_createdTo"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Now</span>
              </template>
              <template #clearbutton>
                <span @click="clear_createdTo"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Clear</span>
              </template>
            </DatePicker>
            <label for="createdTo" class="!bg-slate-900">Create To</label>
          </FloatLabel>
        </div>
        <div class="col-span-6 flex flex-col gap-0.5 text-xs 2xl:text-sm">
          <FloatLabel variant="on">
            <DatePicker
                inputId="updatedFrom"
                v-model="updatedFromModel"
                hourFormat="24"
                dateFormat="d M yy"
                fluid
                :showButtonBar="true"
                class="flex-1"
                size="small"
                :input-class="['!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700']"
                showIcon
                iconDisplay="input"
            >
              <template #todaybutton>
                <span @click="selectNow_updatedFrom"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Now</span>
              </template>
              <template #clearbutton>
                <span @click="clear_updatedFrom"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Clear</span>
              </template>
            </DatePicker>
            <label for="updatedFrom" class="!bg-slate-900">Updated From</label>
          </FloatLabel>
        </div>
        <div class="col-span-6 flex flex-col gap-0.5 text-xs 2xl:text-sm">
          <FloatLabel variant="on">
            <DatePicker
                inputId="updatedTo"
                v-model="updatedToModel"
                hourFormat="24"
                dateFormat="d M yy"
                fluid
                :showButtonBar="true"
                class="flex-1"
                size="small"
                :input-class="['!bg-transparent w-full rounded-md h-[32px] 2xl:h-[40px] !text-xs 2xl:!text-sm !border-slate-700']"
                showIcon
                iconDisplay="input"
            >
              <template #todaybutton>
                <span @click="selectNow_updatedTo"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Now</span>
              </template>
              <template #clearbutton>
                <span @click="clear_updatedTo"
                      class="cursor-pointer px-2 py-1 rounded-md text-xs hover:bg-gray-700/50">Clear</span>
              </template>
            </DatePicker>
            <label for="updatedTo" class="!bg-slate-900">Updated To</label>
          </FloatLabel>
        </div>
      </div>
    </div>
    <div class="flex justify-end gap-3 select-none">
      <button @click="applyFilter"
              class="btn btn-outline-dark flex items-center justify-center gap-3 disabled:opacity-50 py-1">
        <Icon v-if="saving" icon="eos-icons:bubble-loading" height="24"/>
        Apply
      </button>
    </div>
  </Dialog>
</template>
<style></style>